/* BOX IMPORT — Botón "+ Agregar" de los sugeridos del carrito (snippets/bi-sugeridos-carrito.liquid) */
import { CartLinesUpdateEvent, CartErrorEvent } from '@shopify/events';
if (!window.biSugeridosListo) {
  window.biSugeridosListo = true;
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-bi-sug-add]');
    if (!btn || btn.disabled) return;
    btn.disabled = true;
    btn.classList.add('is-cargando');
    const id = btn.dataset.biSugAdd;
    const secciones = [...document.querySelectorAll('cart-items-component')].map((c) => c.dataset.sectionId).filter(Boolean);
    const diferido = CartLinesUpdateEvent.createPromise();
    document.dispatchEvent(new CartLinesUpdateEvent({
      action: 'add', context: 'cart', lines: [{ merchandiseId: id, quantity: 1 }], promise: diferido.promise,
    }));
    try {
      const r = await fetch(Theme.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }], sections: secciones.join(','), sections_url: location.pathname }),
      });
      const res = await r.json();
      const carrito = await (await fetch(Theme.routes.cart_url + '.json', { headers: { Accept: 'application/json' } })).json();
      if (res.status) {
        document.dispatchEvent(new CartErrorEvent({ error: res.message || 'No se pudo agregar', code: 'INVALID' }));
        diferido.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(carrito), detail: { didError: true, items: carrito.items } });
        btn.disabled = false;
        btn.classList.remove('is-cargando');
        btn.querySelector('.bi-sug__btn-txt').textContent = 'Sin stock';
        return;
      }
      diferido.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(carrito),
        detail: { items: carrito.items, itemCount: carrito.item_count, sections: res.sections, source: 'bi-sugeridos', didError: false },
      });
    } catch (err) {
      diferido.reject(err);
      btn.disabled = false;
      btn.classList.remove('is-cargando');
    }
  });
}

/* BOX IMPORT — Tarjetas de producto: porcentaje de descuento real, ahorro en pesos, botón "Ver producto"
   y aparición suave al hacer scroll. Funciona también con las tarjetas que se cargan después (filtros, más productos). */
if (!window.biTarjetasListo) {
  window.biTarjetasListo = true;
  const aNumero = (t) => Number(String(t).replace(/[^\d,]/g, '').split(',')[0]);
  const pesos = (n) => '$' + n.toLocaleString('es-AR');
  const visto = 'IntersectionObserver' in window
    ? new IntersectionObserver((entradas) => entradas.forEach((e) => {
        if (e.isIntersecting) { e.target.classList.add('bi-in'); visto.unobserve(e.target); }
      }), { rootMargin: '0px 0px -6% 0px' })
    : null;

  const mejorar = () => {
    document.querySelectorAll('.product-card:not([data-bi-card])').forEach((card, i) => {
      card.dataset.biCard = '1';
      /* Precios sin los centavos: $47.990 en vez de $47.990,00 */
      card.querySelectorAll('product-price bdi').forEach((b) => { b.textContent = b.textContent.replace(/,00\s*$/, ''); });
      const precio = card.querySelector('product-price .price bdi');
      const antes = card.querySelector('product-price .compare-at-price bdi');
      if (precio && antes) {
        const p = aNumero(precio.textContent), a = aNumero(antes.textContent);
        if (a > p && p > 0) {
          const insignia = card.querySelector('.product-badges__badge');
          if (insignia) insignia.textContent = '-' + Math.round(((a - p) / a) * 100) + '%';
          const ahorro = document.createElement('span');
          ahorro.className = 'bi-card-ahorro';
          ahorro.textContent = 'Ahorrás ' + pesos(a - p);
          card.querySelector('product-price').after(ahorro);
        }
      }
      /* Botón "Ver producto": es un enlace real al producto (el resto de la tarjeta ya enlaza desde la foto y el título) */
      const contenido = card.querySelector('.product-card__content');
      const enlace = card.querySelector('a.product-card__link, a[href*="/products/"]');
      if (contenido && enlace) {
        const cta = document.createElement('a');
        cta.className = 'bi-card-cta';
        cta.href = enlace.getAttribute('href');
        cta.tabIndex = -1;
        cta.style.pointerEvents = 'auto';
        cta.style.textDecoration = 'none';
        cta.style.position = 'relative';
        cta.style.zIndex = '2';
        cta.innerHTML = 'Ver producto <i>→</i>';
        contenido.appendChild(cta);
      }
      card.style.setProperty('--bi-retraso', (i % 4) * 70 + 'ms');
      if (visto) visto.observe(card); else card.classList.add('bi-in');
    });
  };

  document.documentElement.classList.add('bi-js');
  mejorar();
  let espera;
  new MutationObserver(() => { clearTimeout(espera); espera = setTimeout(mejorar, 120); }).observe(document.body, { childList: true, subtree: true });
}
